module.exports = __webpack_public_path__ + "img/2BE1C.3eecc7fb.svg";